<script>
  export default {
    mounted() {
    },
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/aprovar-pesquisa-preco/componentes/AprovarPesquisaPreco.vue